import { connect } from "react-redux";
import { onLogout } from "frame";
import Logout from "./logout";

const mapDispatchToProps = {
	onLogout,
};

export default connect(null, mapDispatchToProps)(Logout);
